<template>
	<router-link
		class="product-link"
		:to="{ name: route, params: { productId: product.id } }">
		<v-card class="mx-auto productCard" max-width="280" :loading="loading">
			<template v-slot:loader="{ isActive }">
				<v-progress-linear
					:active="isActive"
					color="deep-purple"
					height="4"
					indeterminate
				></v-progress-linear>
			</template>
			<v-img
				v-if="product.img_path"
				:src="`${product.img_path}`"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<v-img
				v-else
				src="@/assets/static/images/noImage.png"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<div style="text-align: left">
				<div class="card-title bold">{{product.name}}</div>
				<v-card-subtitle style="padding-top: 0px; width: 220px;">{{product.prodCat}}</v-card-subtitle>
			</div>
			<div class="iconWrapper">
				<div v-if="product.shippable==1" class="primaryIcon">
					<font-awesome-icon icon="shipping-fast" />
				</div>
				<div v-if="product.wholesalable==1" class="baseIcon">
					<font-awesome-icon icon="store" />
				</div>		
			</div>
		</v-card>
	</router-link>
</template>

<script>

export default {

  data() {
    return {
      id: this.product.id,
      baseUrl: process.env.VUE_APP_API_URL,
	  loading: false,
    }
  },
  methods: {
    deleteProduct(event) {
      event.preventDefault()
      if (confirm('are you sure?')) {
        if (this.experience) {
          this.$store
            .dispatch('experience/removeExperience', this.id)
            .then(() => {
              this.$store.dispatch('experience/fetchExperiences')
            })
            .catch((e) => console.log(e))
        } else {
          this.$store
            .dispatch('product/removeProduct', this.id)
            .then(() => {
              this.$store.dispatch('product/fetchProducts')
            })
            .catch((e) => console.log(e))
        }
      }
    },
    setFeatured(featuredFlag) {
      this.product.featured = featuredFlag
      this.$store.dispatch('product/editProduct', this.product)
    },
	reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
    },
  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      },
    },
    route: {
      type: String,
      default: 'product',
    },
    experience: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.product-link {
	text-decoration: none;
}
.fitProductImage {
	width: 100% !important;
  	object-fit: cover !important;
}

.productCard {
	height: 300px;
	margin: 20px 10px !important;
	}

.card-title {
	width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin: 15px 15px 0px 15px;
	text-align: left;
	font-size: 1.2rem;
	font-weight: 800;
}
.bold {
	font-weight: 700 !important;

}

.iconWrapper {
	display: flex;
	flex-wrap: nowrap;
	align-items: right;
	justify-content: right;
	margin: -45px 5px 5px -5px;
}

.iconWrapper div {
    padding: 7px;
	margin-left: 2px;
	align-self: flex-end;
}

.primaryIcon {
    color: var(--primaryDark);
}

.baseIcon {
    color: var(--bg);
}
/* .card-name {
  color: #454655;
}
.card-text {
  color: #454655;
} */
.product-price {
  font-size: 2em;
}
.featuredIcon {
	border-radius: 10px !important;
}

.trashIcon {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 40px;
  position: relative;
  display: block;
  top: -140px;
  left: -20px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
@media only screen and (max-device-width: 769px) {
	.productCard {
		height: auto !important;
	}
}
@media only screen and (min-width: 500px) {
	.productCard:hover {
	background: rgba(128, 128, 128, 0.1) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}
}
@media screen and (max-width: 500px) {
.productCard {
    margin: auto !important;
	margin-bottom: 15px !important;
  }

  .card-title {
    // width: 100%;
	margin-top: 10px;
    // font-size: 1rem;
	text-decoration:none;
  }
  .iconWrapper {
    margin: -5px 5px 5px -5px !important;
}
}

@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
	text-align: left;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 255px;
}
}


</style>
